import React, { useState, useEffect } from 'react';
import './App.css';




const regionNames = new Intl.DisplayNames(['en'], { type: 'region' });



const App = () => {

  const [country, setCountry] = useState('');
  const [region, setRegion] = useState('');
  const [city, setCity] = useState('');
  const [fetchAttempted, setFetchAttempted] = useState(false);
  const currentDate = new Date();
  const [timeLeft, setTimeLeft] = useState(10 * 60);



  useEffect(() => {
    setFetchAttempted(true); // Set to true as fetch begins
  
    fetch('/api/location')
      .then(response => response.json())
      .then(data => {
        const decodedCity = decodeURIComponent(data.city.replace(/\+/g, ' '));
  
        if (decodedCity === "unknown") {
          // If city is "unknown", fetch from the external API
          fetch('https://freeipapi.com/api/json/')
            .then(response => response.json())
            .then(externalData => {
              const externalDecodedCity = decodeURIComponent(externalData.cityName.replace(/\+/g, ' '));
              setCountry(externalData.countryCode);
              setCity(externalDecodedCity);
              console.log(externalData); // Log the external API data
            })
            .catch(error => {
              console.error('Fetch error on external API:', error);
            });
        } else {
          // Use the local API data
          setCountry(data.country);
          setRegion(regionNames.of(data.country.toUpperCase())); // Assumes regionNames is defined and imported
          setCity(decodedCity);
          console.log(data); // Log the local API data
        }
      })
      .catch(error => {
        console.error('Fetch error on local API:', error);
        // Optionally handle the error by fetching from external API or other means
      });
  
  }, []);

  return (
    <div style={{ margin: 0, fontFamily: 'Arial, sans-serif', textAlign: 'center' }}>
      {/* Background */}
      <div
        style={{
          display: 'block',
          position: 'fixed',
          left: 0,
          top: 0,
          width: '100%',
          height: '100%',
          zIndex: -10,
          backgroundPosition: 'center center',
          backgroundSize: 'cover',
          backgroundImage:
            'radial-gradient(rgb(245, 169, 184), rgb(91, 206, 250))',
        }}
      ></div>

      {/* Header */}
      <header
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '10px 20px',
        }}
      >


      </header>

      {/* Profile Section */}
      <div className="profile-section" style={{ marginTop: '30px' }}>
        <img
          alt="profile"
          src="https://cdn.beacons.ai/user_content/QP9xzaqVaXgjwQKu2wEwnbByP3T2/profile_tsalex.png?t=1727466847532"
          style={{
            width: '130px',
            height: '130px',
            borderRadius: '10000px',
            border: '2px solid rgb(254, 254, 254)',
          }}
        />
        <h2
          style={{
            borderRadius: '36px',
            color: 'rgb(254, 254, 254)',
            fontFamily: 'Poppins, sans-serif',
            fontWeight: 600,
            fontSize: '21px',
            marginTop: '16px',
          }}
        >
          Alex ♡🏳️‍⚧️
        </h2>
        <div id="user-status" className="user-status">
                      <div className="status"></div>
                      <div id="available"><strong>Available now</strong></div>
                      <div className="separator"></div>
                      <div className="location"></div>
                      <div className="respond-time"><strong>{city || 'Miami'}</strong></div>
                    </div>
        <p
          style={{
            borderRadius: '36px',
            color: 'rgb(254, 254, 254)',
            fontFamily: 'Poppins, sans-serif',
            fontWeight: 600,
            fontSize: '16px',
            marginBottom: '8px',
            padding: '0 40px',
          }}
        >
          Click below for my exclusive content 👇
        </p>
      </div>

      {/* OnlyFans Button Section */}
      <div className="button-section" style={{ marginTop: '20px' }}>
      <a
  href="https://bouncy.ai/alextsgirl"
  aria-label="OnlyFans 70% OFF"
  className="pulsing-button"
  style={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderRadius: '36px',
    backgroundColor: 'rgb(91, 206, 250)',
    color: 'rgb(254, 254, 254)',
    fontFamily: 'Poppins, sans-serif',
    textTransform: 'none',
    boxShadow: 'none',
    fontSize: '15px',
    height: '65px',
    padding: '0 20px',
    margin: '16px auto',
    border: '2px solid rgb(254, 254, 254)',
    textDecoration: 'none',
    width: '300px',
  }}
>
  <img
    src="https://cdn.jsdelivr.net/npm/simple-icons@13.17.0/icons/onlyfans.svg"
    alt="OnlyFans Icon"
    style={{
      width: '45px',
      height: '45px',
      filter:
        'invert(98%) sepia(2%) saturate(133%) hue-rotate(234deg) brightness(107%) contrast(99%)',
    }}
  />
  <div style={{ flexGrow: 1, textAlign: 'center' }}>
    <div style={{ fontSize: '16px', fontWeight: 'bold' }}>OnlyFans 60% OFF</div>
    <div style={{ fontSize: '14px' }}>🟢 ONLINE</div>
  </div>
  <img
    src="https://i.ibb.co/KmFr6VH/1024px-HD-transparent-picture.png"
    alt="OnlyFans Icon"
    style={{ width: '45px', height: '45px' }}
  />
</a>

      </div>
    </div>
  );
};

export default App;
